export default __webpack_public_path__ + "static/media/become_a_charity_partner.5b79e068.png";